// Queue panel — the live MusicKit queue as provider-neutral rows. Read via the provider
// (no MusicKit in the component). Now Playing pinned at top, Up Next below.
import React from 'react';
import { ListMusic } from 'lucide-react';
import { appleMusicProvider } from '../lib/appleMusicProvider';
import { usePlayerSnapshot } from './usePlayer';
import type { MusicItem } from '../lib/types';

const provider = appleMusicProvider();
const art = (i: MusicItem, px = 40) => provider.artworkUrl(i.artwork, px);

export const QueuePanel: React.FC = () => {
  const snap = usePlayerSnapshot(); // re-renders on queue change
  const { current, items } = provider.queueItems();
  const upNext = items.slice(current + 1);

  return (
    <div className="flex h-full flex-col">
      {snap.item && (
        <div>
          <div className="px-1 pb-1.5 text-xs font-medium text-muted-foreground">Now playing</div>
          <Row item={snap.item} active />
        </div>
      )}
      <div className="mt-3 min-h-0 flex-1 overflow-y-auto">
        <div className="px-1 pb-1.5 text-xs font-medium text-muted-foreground">Up next</div>
        {upNext.length === 0 && <p className="px-1 text-sm text-muted-foreground">Nothing queued.</p>}
        <ul className="space-y-0.5">{upNext.map((i, idx) => <li key={`${i.id}-${idx}`}><Row item={i} /></li>)}</ul>
      </div>
    </div>
  );
};

const Row: React.FC<{ item: MusicItem; active?: boolean }> = ({ item, active }) => (
  <div className={`flex items-center gap-3 rounded-lg p-2 ${active ? 'bg-accent' : 'hover:bg-muted'}`}>
    {art(item) ? <img src={art(item)} alt="" className="h-10 w-10 rounded object-cover" /> : <div className="flex h-10 w-10 items-center justify-center rounded bg-muted"><ListMusic className="h-4 w-4 text-muted-foreground" /></div>}
    <div className="min-w-0 flex-1">
      <div className="truncate text-sm font-medium text-foreground">{item.title}</div>
      <div className="truncate text-xs text-muted-foreground">{item.artist || item.subtitle}</div>
    </div>
  </div>
);
